module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper long-contents"
  }, [_c('div', {
    staticClass: "login background-color long-contents"
  }, [_c('app-header-noauth'), _c('div', {
    staticClass: "div"
  }, [_c('div', {
    staticClass: "row margin-top"
  }), _c('label', {
    staticClass: "col-xs-8 control-label margin-top margin-left margin-right login-title"
  }, [_vm._v(_vm._s(_vm.$t('Login Title')))]), _c('div', {
    staticClass: "row margin-top"
  }), _c('form', {
    staticClass: "center-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-11 control-label margin-top margin-left margin-right"
  }, [_vm._v(_vm._s(_vm.$t('Login ID')))])]), _c('div', {
    staticClass: "col-xs-11 margin-left margin-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginId),
      expression: "loginId"
    }],
    staticClass: "form-control",
    style: (_vm.border()),
    attrs: {
      "id": "login_id",
      "type": "text",
      "name": "loginId"
    },
    domProps: {
      "value": (_vm.loginId)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginId = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-11 control-label margin-top margin-left margin-right"
  }, [_vm._v(_vm._s(_vm.$t('Password')))])]), _c('div', {
    staticClass: "col-xs-11 margin-left margin-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    style: (_vm.border()),
    attrs: {
      "id": "password",
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger margin-left margin-right"
  }, [_vm._v("ログインIDかパスワードが不正です。")]) : _vm._e(), _vm._m(0), _c('div', {
    staticClass: "row"
  }, [_c('br'), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keepLogin),
      expression: "keepLogin"
    }],
    attrs: {
      "type": "checkbox",
      "id": "keepLogin"
    },
    domProps: {
      "checked": Array.isArray(_vm.keepLogin) ? _vm._i(_vm.keepLogin, null) > -1 : (_vm.keepLogin)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.keepLogin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.keepLogin = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.keepLogin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.keepLogin = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "small margin-left-small"
  }, [_vm._v("ログイン状態を保持")])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-11 margin-left margin-right"
  }, [_c('a', {
    staticClass: "col-xs-12 btn btn-default btn-lg bg-success btn-gradation",
    attrs: {
      "id": "logion"
    },
    on: {
      "click": _vm.login
    }
  }, [_c('span', {
    staticClass: "login-btn"
  }, [_vm._v(_vm._s(_vm.$t('Login Button')) + " ")]), _c('i', {
    staticClass: "fa fa-chevron-right",
    staticStyle: {
      "color": "white"
    }
  })])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('router-link', {
    attrs: {
      "to": "/forgot_password"
    }
  }, [_c('u', {
    staticClass: "span"
  }, [_vm._v(_vm._s(_vm.$t('login.forgot_password')))]), _c('br'), _c('u', {
    staticClass: "span"
  }, [_vm._v(_vm._s(_vm.$t('login.forgot_password_note')))])])], 1)])])])])], 1), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "helpModalButton",
      "type": "button",
      "data-backdrop": "static",
      "data-toggle": "modal",
      "data-target": "#helpModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "help-modal",
    attrs: {
      "id": "helpModal"
    }
  }, [_c('div', {
    staticClass: "help-modal__body bg03",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_vm._m(1), _vm._m(2), _c('button', {
    staticClass: "btn01 moral-going__modal-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.goTop
    }
  }, [_c('span', [_vm._v("閉じる")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "heading_01 mb25"
  }, [_vm._v("熱い想いがあって"), _c('br'), _vm._v("社内SNS"), _c('br'), _vm._v("“WONDER WORLD”を"), _c('br'), _vm._v("作ったんだニャン♪")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_01 help-modal__body__txt -login-done"
  }, [_c('p', [_vm._v("みんな、いつもありがとう！"), _c('br'), _vm._v("お疲れ様ですニャン！")]), _c('p', [_vm._v("タイラニャンは、「タイラベストビート」を、より素敵な会社にしたいんだニャン！")]), _c('p', [_vm._v("そのためには、やっぱりみんなの声をきくのが一番！")]), _c('p', [_vm._v("お客様は勿論、会社のみんなにも、「居心地のいい、素敵な会社だ」と思ってもらえるように、がんばりたいんだニャン♪")]), _c('p', [_vm._v("“WONDER WORLD”、気軽に使ってほしいニャン♪")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65eb1dc8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/login.pug
// module id = 1409
// module chunks = 1